"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConvertItemObject = void 0;
const createConvertItemObject = convertItemValue => object => {
  const entries = Object.entries(object).filter(([, value]) => value !== undefined).map(([key, value]) => [key, convertItemValue(value)]);
  return Object.fromEntries(entries);
};
exports.createConvertItemObject = createConvertItemObject;